import React, { useState, useEffect, useRef } from "react";
import lib from "./lib";
const hooks = {
    useGetAuthButtons: ({ systemCode: code, pagePath: path } = {}) => {
        const [buttons, setButtons] = useState([]);
        const systemCode = code || lib.config.systemCode;
        const pagePath = path || window.location.pathname;
        const data = { systemCode, pagePath };
        const getAuthBtns = async () => {
            const res = await lib.request({
                url: "/ucenter-account/current/lastButtonList",
                data,
            });
            if (res && Array.isArray(res)) {
                const formatBtns = res.map(i => i.code);
                setButtons(formatBtns);
            }
        };
        useEffect(() => {
            getAuthBtns();
        }, [systemCode, pagePath]);
        return [buttons];
    },
    useTitle: (title = "", options) => {
        const prevTitleRef = useRef(document.title);
        document.title = title;
        useEffect(() => {
            if (options && options.restoreOnUnmount) {
                return () => {
                    document.title = prevTitleRef.current;
                };
            } else {
                return;
            }
        }, []);
        return title;
    },
    useSaasInfo: () => {
        const [sassInfo, setSassInfo] = useState({
            id: "", // 系统id
            copyright: "", // 版权信息
            loginPic: "", // 登录页背景图片
            logo: "", // logo
            pageFooter: "", // 页脚
            systemName: "", // 系统名称
        });
        const [loading, setLoading] = useState(true);
        useEffect(() => {
            // debugger
            lib.request({
                // url: 'https://www.fastmock.site/mock/c96315b78e40418fc3787cd4c1f51040/ucenter-account/logo',
                // url: 'http://yapi.yang800.cn/mock/365/ucenter-config/personal/query',
                url: "/ucenter-config/personal/query",
                data: {
                    domain: location.host,
                },
                methods: "POST",
                success: res => {
                    setLoading(false);
                    res && setSassInfo(res);
                },
                fail: err => {
                    console.error(err);
                },
            });
        }, []);

        return [sassInfo, loading];
    },
};
export default hooks;
